"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
var _JsonEditor = _interopRequireDefault(require("@/components/JsonEditor"));
var _syslog = require("@/api/log/syslog");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function toTimestamp(dateStr) {
  return Math.floor(new Date(dateStr.replace(/-/g, '/')).getTime() / 1000);
}
var _default = exports.default = {
  name: 'logOperator',
  components: {
    JsonEditor: _JsonEditor.default
  },
  data: function data() {
    var today = new Date();
    var todayStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
    return {
      listLoading: false,
      list: [],
      total: 0,
      dateRange: [todayStr + ' 00:00:00', todayStr + ' 23:59:59'],
      listQuery: {
        page: 1,
        limit: 10,
        component: '',
        operation: '',
        startTime: toTimestamp(todayStr + ' 00:00:00'),
        endTime: toTimestamp(todayStr + ' 23:59:59')
      },
      operationList: [],
      dialogVisible: false,
      paramsContent: ''
    };
  },
  created: function created() {
    this.getList();
    this.getOperations();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = _objectSpread({}, this.listQuery);
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = toTimestamp(this.dateRange[0]);
        params.endTime = toTimestamp(this.dateRange[1]);
      }
      (0, _syslog.fetchList)(params).then(function (response) {
        _this.list = response.records || [];
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getOperations: function getOperations() {
      var _this2 = this;
      (0, _syslog.getOperationList)().then(function (response) {
        _this2.operationList = response.data || [];
      });
    },
    handleQuery: function handleQuery() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.listQuery.page = current;
      this.getList();
    },
    showParams: function showParams(row) {
      if (row.params) {
        try {
          this.paramsContent = JSON.parse(row.params);
        } catch (e) {
          this.paramsContent = row.params;
        }
      }
      this.dialogVisible = true;
    },
    formatTime: function formatTime(val) {
      if (!val) return '';
      var d = new Date(val * 1000);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    }
  }
};